var _rect, _path, _path2, _path3, _path4, _path5, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconremoved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#7D7D7D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6873 7.9375L7.31226 7.93751",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 11.3125V15.8125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 11.3125V15.8125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 5.6875H16.3125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5623 7.9375V18.625C18.5623 18.7742 18.503 18.9173 18.3975 19.0227C18.292 19.1282 18.1489 19.1875 17.9998 19.1875H8.99976C8.85057 19.1875 8.7075 19.1282 8.60201 19.0227C8.49652 18.9173 8.43726 18.7742 8.43726 18.625V7.9375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 12.5,
    stroke: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconremoved);
export default __webpack_public_path__ + "static/media/iconremoved.7d9b580373c5f8f6397dc7c9a9425711.svg";
export { ForwardRef as ReactComponent };